export default __webpack_public_path__ + "static/media/008-business.a96ceb9e.svg";